import { useTranslation } from 'react-i18next';

import { useTutorDashboardReport } from '../../../hooks/useTutorDashboardReport';
import { UsagePanelStatus } from '../../molecules/UsagePanelStatus';
import { UsageEvolutionChart } from '../UsageEvolutionChart';
import { UsageKpiRow } from '../UsageKpiRow';

/**
 * Painel da aba "Visão geral": seis indicadores do período, mais a evolução diária de
 * tokens e de mensagens.
 *
 * Os dois painéis do gráfico dividem o eixo X e um `syncId`, então a relação entre custo e
 * engajamento se lê na vertical — um eixo Y duplo alinharia as duas escalas arbitrariamente
 * e inventaria uma correlação que a diferença de grandeza não sustenta.
 *
 * É dono da própria consulta: montado só quando a aba está ativa, então a aba inativa não
 * dispara request.
 */
export function UsageOverviewPanel() {
  const { t } = useTranslation('tutorAI');
  const { report, timeline, isLoading, isError, isPeriodValid, refetch } =
    useTutorDashboardReport();

  return (
    <UsagePanelStatus
      isPeriodValid={isPeriodValid}
      isError={isError}
      errorMessage={t('usage.loadError')}
      onRetry={() => void refetch()}
    >
      <div className="flex flex-col gap-xs">
        <UsageKpiRow report={report} isLoading={isLoading} />
        <UsageEvolutionChart timeline={timeline} isLoading={isLoading} />
      </div>
    </UsagePanelStatus>
  );
}
